import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { ModalManager } from "@/react/components/Layout/ModalManagerProvider";
import { ShareNotice } from "@/react/components/shared/ModalsV2/MomentumModal/ShareNotice";
import { getMomentumModalConfig } from "@/react/components/shared/ModalsV2/MomentumModal/config";
import { useCreateWorkflow } from "@/react/hooks/useCreateWorkflow";
import type { Paywall } from "@circle-react/types/Paywall";
import { Icon } from "@circle-react-shared/Icon";
import { MomentumModal } from "@circle-react-shared/ModalsV2/MomentumModal";
import { ActionButton } from "@circle-react-shared/ModalsV2/MomentumModal/ActionButton";

const localeNamespace = "settings.paywalls.paywall_momentum_modal";

export const PaywallMomentumModal = ModalManager.create(function PaywallMoMo({
  paywall,
  onClose,
}: {
  paywall: Paywall;
  onClose?: () => void;
}) {
  const modal = useModal();

  const modalConfig = getMomentumModalConfig("paywall_momo");
  const { createFromTemplate, isLoading } = useCreateWorkflow({
    templateKey: modalConfig?.template_key ?? "",
    isAutomationWorkflow: modalConfig?.template_type === "dynamic",
  });

  const handleCreateWorkflow = () => {
    void createFromTemplate(undefined, {
      onSuccess: () => {
        void modal.hide();
      },
    });
  };

  const handleClose = () => {
    void modal.hide();
    onClose?.();
  };

  return (
    <MomentumModal
      isOpen={modal.visible}
      onClose={handleClose}
      title={t(`${localeNamespace}.paywall_created`)}
      description={t(`${localeNamespace}.paywall_created_description`, {
        paywall_display_name: paywall.display_name,
      })}
      isLoading={isLoading}
      data-testid="paywall-momentum-modal"
    >
      <ShareNotice
        title={t([localeNamespace, "workflow_trigger_section.title"])}
        description={t([
          localeNamespace,
          "workflow_trigger_section.description",
        ])}
      >
        <ActionButton
          iconEl={<Icon type="16-lightning-filled" size={16} />}
          onClick={handleCreateWorkflow}
          disabled={isLoading}
        >
          {t([localeNamespace, "workflow_trigger_section.cta"])}
        </ActionButton>
      </ShareNotice>
    </MomentumModal>
  );
});
